import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import "../assets/styles/output.css";
import AddProduct from "../components/AddProduct/AddProduct";
import Navbar from "../components/Navbar/Navbar";
import ProductItem from "../components/ProductItem/ProductItem";

export default function Home() {
  const products = useSelector((state) => state.productItems.products);

  return (
    <Fragment>
      <div>
        <Navbar />

        <main className="py-16">
          <div className="productWrapper">
            {/* <!-- products container --> */}
            <div className="productContainer" id="lws-productContainer">
              {/* <!-- product item --> */}
              {products.length > 0 ? (
                products.map((product) => (
                  <ProductItem product={product} key={product.id} />
                ))
              ) : (
                <p>No products found.</p>
              )}
            </div>
            <div>
              {/*<!-- Product Input Form -->*/}

              <AddProduct />
            </div>
          </div>
        </main>
      </div>
    </Fragment>
  );
}
